import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import { Box } from "@mui/system";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function SelectOption({
  onChange,
  error,
  helperText,
  options = [],
  label,
  value,
  name,
  optionValuePropName = "value",
  optionTextPropName = "text",
  disabled = false,
  noneText = "None",
  showNone = false,
}) {
  return (
    <Box sx={{ m: 1, my: 2 }}>
      <FormControl disabled={disabled} fullWidth>
        <Typography variant="subtitle1">
          {label}
        </Typography>
        <Select
          size="small"
          value={value}
          name={name}
          error={error}
          disabled={disabled}
          placeholder="xxxx"
          onChange={(e) => onChange(e)}
          sx={{ backgroundColor: disabled ? "#eef1f5" : "white" }}
          MenuProps={MenuProps}
        >
          <MenuItem key={0} sx={{ display: !showNone && "none" }} value="">
            {noneText}
          </MenuItem>
          {options.length > 0 &&
            options.map((option, index) => {
              return (
                <MenuItem key={index + 1} value={option[optionValuePropName]}>
                  {option[optionTextPropName]}
                </MenuItem>
              );
            })}
        </Select>
        {error && (
          <FormHelperText sx={{ color: "red" }}>{helperText}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

export default SelectOption;
